@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  /* ═══════════════════════════════════════════════════════════
     LAYER 1 — PRIMITIVE TOKENS (raw design values)
  ═══════════════════════════════════════════════════════════ */
  :root {
    /* Blue scale — medical primary */
    --color-blue-50:  #EFF6FF;
    --color-blue-100: #DBEAFE;
    --color-blue-200: #BFDBFE;
    --color-blue-400: #60A5FA;
    --color-blue-500: #3B82F6;
    --color-blue-600: #2563EB;
    --color-blue-700: #1D4ED8;
    --color-blue-900: #1E3A8A;

    /* Navy scale — nav & dark surfaces */
    --color-navy-700: #1E293B;
    --color-navy-800: #0F172A;
    --color-navy-900: #020617;

    /* Slate/Gray scale */
    --color-gray-50:  #F8FAFC;
    --color-gray-100: #F1F5F9;
    --color-gray-200: #E2E8F0;
    --color-gray-300: #CBD5E1;
    --color-gray-400: #94A3B8;
    --color-gray-500: #64748B;
    --color-gray-600: #475569;
    --color-gray-700: #334155;
    --color-gray-900: #0F172A;

    /* Semantic foot colors */
    --color-foot-left:  #3B82F6;   /* blue-500 */
    --color-foot-right: #22C55E;   /* green-500 */

    /* Status */
    --color-success: #16A34A;
    --color-warning: #D97706;
    --color-error:   #DC2626;

    /* ═══════════════════════════════════════════════════════
       LAYER 2 — SEMANTIC TOKENS (purpose-based)
    ═══════════════════════════════════════════════════════ */

    /* shadcn/ui required vars (HSL format) */
    --background: 210 40% 98%;
    --foreground: 221 39% 11%;

    --card: 0 0% 100%;
    --card-foreground: 221 39% 11%;

    --popover: 0 0% 100%;
    --popover-foreground: 221 39% 11%;

    /* Medical blue primary: #2563EB = hsl(221, 83%, 53%) */
    --primary: 221 83% 53%;
    --primary-foreground: 0 0% 100%;

    --secondary: 210 40% 96%;
    --secondary-foreground: 221 39% 11%;

    --muted: 210 40% 96%;
    --muted-foreground: 215 16% 47%;

    --accent: 210 40% 96%;
    --accent-foreground: 221 39% 11%;

    --destructive: 0 84% 60%;
    --destructive-foreground: 0 0% 100%;

    --border: 214 32% 91%;
    --input: 214 32% 91%;
    --ring: 221 83% 53%;

    --radius: 0.5rem;

    /* ═══════════════════════════════════════════════════════
       LAYER 3 — COMPONENT TOKENS
    ═══════════════════════════════════════════════════════ */

    /* Shadows (CSS only) */
    --shadow-sm:  0 1px 2px rgba(0,0,0,0.05);
    --shadow-md:  0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.04);
    --shadow-lg:  0 4px 16px rgba(0,0,0,0.10), 0 2px 4px rgba(0,0,0,0.05);
    --shadow-xl:  0 8px 40px rgba(0,0,0,0.16), 0 2px 8px rgba(0,0,0,0.06);

    /* Nav */
    --nav-bg:          var(--color-navy-800);
    --nav-text:        var(--color-gray-400);
    --nav-text-hover:  #CBD5E1;
    --nav-active-text: #ffffff;
    --nav-active-bg:   rgba(59,130,246,0.12);
    --nav-active-border: var(--color-blue-500);
    --nav-border:      rgba(255,255,255,0.07);
    --nav-width: 220px;

    /* Buttons */
    --btn-primary-bg:    var(--color-blue-600);
    --btn-primary-hover: var(--color-blue-700);

    /* App layout */
    --app-bg: var(--color-gray-100);
    --page-header-bg: #ffffff;
    --surface: #ffffff;
    --surface-2: var(--color-gray-50);
    --border-color: var(--color-gray-200);

    /* Cards */
    --card-radius: 10px;
    --card-shadow: var(--shadow-md);
    --card-hover-shadow: var(--shadow-lg);
    --card-border: var(--color-gray-200);
  }
}
